import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { usePromptLibrary } from '../../../PromptLibraryProvider';
import { CardBody, PreviewContent, PreviewOverlay } from './styled';
export function ContentContainer(props) {
    const { children, promptId } = props;
    const { setCurrentPromptID } = usePromptLibrary();
    return (<CardBody onClick={() => setCurrentPromptID(promptId)}>
      <PreviewContent>{children}</PreviewContent>
      <PreviewOverlay>
        <Box p="sm" borderRadius="md" bg="background.75">
          <Typography $fontSize="small" $fontWeight="bold" $appearance="100">
            <Trans comment="Prompt Library - Preview prompt button">Click to preview</Trans>
          </Typography>
        </Box>
      </PreviewOverlay>
    </CardBody>);
}
